'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexItem = exports.FlexContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Flex container - use this instead of bulma columns when you don't want the extra
 * cruft of the bulma grid.
 */
var FlexContainer = function FlexContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      style = _ref.style,
      direction = _ref.direction,
      justifyContent = _ref.justifyContent,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'alignItems', 'alignContent', 'style', 'direction', 'justifyContent']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)('FlexContainer', className), style: (0, _extends3.default)({ alignItems: alignItems, flexDirection: direction, justifyContent: justifyContent, alignContent: alignContent }, style) }, props),
    children
  );
};

exports.FlexContainer = FlexContainer;
FlexContainer.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse', 'initial', 'inherit']),
  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around', 'initial', 'inherit']),
  alignItems: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  justifyContent: _propTypes2.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'initial', 'inherit'])
};

/**
 * Flex item.
 */
var FlexItem = function FlexItem(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      stretch = _ref2.stretch,
      vcentered = _ref2.vcentered,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['children', 'className', 'stretch', 'vcentered']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('FlexItem', {
        'FlexItem--stretch': stretch,
        'FlexItem--vcentered': vcentered
      }, className)
    }, props),
    children
  );
};

exports.FlexItem = FlexItem;
FlexItem.propTypes = {
  className: _propTypes2.default.string,
  stretch: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  vcentered: _propTypes2.default.bool
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Flex/index.js
// module id = 38
// module chunks = 0